import { defineMessages } from 'react-intl';

export default defineMessages({
    flexValidationErrorMessage: {
        id: 'wmic-pe-capability-gateway-common-react.components.WMICFlexValidationErrorMessage.WMICFlexValidationErrorMessage.The original base premium has been changed. Please open the Flex Program to review and adjust before binding the transaction.',
        defaultMessage:
            'The original base premium has been changed. Please open the Flex Program to review and adjust before binding the transaction.',
    },
});
